const MarkSheets = () => {
  return <div data-testid="mark-sheets"><h1 className="text-2xl font-bold">Mark Sheets</h1><p className="text-gray-600 mt-4">Upload and manage mark sheets</p></div>;
};
export default MarkSheets;
